import { useEffect, useRef } from 'react';

type Callback = () => void;

export default function useInterval(
  callback: Callback,
  delayMs: number | null
) {
  const savedCallback = useRef<Callback>();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current?.();
    }
    if (delayMs !== null) {
      const id = setInterval(tick, delayMs);
      return () => clearInterval(id);
    }
  }, [delayMs]);
}
